import { createContext } from 'react';

import { IPhoneContextValue } from './types';

export const PhoneContext = createContext<IPhoneContextValue>({
  translate: (val: string) => val,
});
